import api from '../utils/api';

const BASE = '/api/calendar';

/**
 * Fetch the signed-in user's calendar for a window: their classrooms (each with the role
 * they hold in it) and every assignment from those classrooms that falls in the window.
 * @route GET /api/calendar/events
 * @param {{start: string, end: string}} range - ISO instants; [start, end), at most 100 days.
 * @param {{signal?: AbortSignal}} [options]
 * @returns {Promise<{classrooms: Object[], events: Object[], truncated: boolean}>}
 */
export const getCalendarEvents = ({ start, end }, { signal } = {}) =>
    api.get(`${BASE}/events`, { params: { start, end }, signal }).then((r) => r.data);
